import { ModalTypeMap } from "@mui/material";
import { CloseIcon } from "../icons";
import {
  CloseButton,
  ModalCardContainer,
  ModalContentContainer,
  StyledModal,
} from "./styled";
import { CustomModalProps } from "src/types";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { forwardRef } from "react";

export const CustomModal = forwardRef(
  (
    {
      isOpen,
      onCloseModal,
      children,
      cardStyles,
      contentContainerStyles,
      sxContentStyles,
      hideCloseButton,
      ...props
    }: CustomModalProps &
      Omit<OverridableComponent<ModalTypeMap>, "open" | "onClose">,
    ref
  ) => {
    return (
      <StyledModal open={isOpen} onClose={onCloseModal} {...props}>
        <ModalContentContainer style={contentContainerStyles}>
          {!hideCloseButton && (
            <CloseButton
              variant="contained"
              color="secondaryLight"
              onClick={onCloseModal}
            >
              Close <CloseIcon />
            </CloseButton>
          )}
          <ModalCardContainer
            ref={ref}
            sx={{
              backgroundColor: "white.main",
              ...sxContentStyles,
            }}
            style={cardStyles}
          >
            {children}
          </ModalCardContainer>
        </ModalContentContainer>
      </StyledModal>
    );
  }
);
